"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APIconButton = _interopRequireDefault(require("../common/APIconButton/APIconButton"));
var _APIFrame = _interopRequireDefault(require("../common/APIFrame/APIFrame"));
require("./DigitalAssetsOfferingProfilePage.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TotalTokensCount = require("./TotalTokensCount");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var classes = (0, _cssClassesHelper.getBEMClasses)('offering-profile');
var DigitalAssetsOfferingProfilePage = function DigitalAssetsOfferingProfilePage(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  var ProductId = props.ProductId,
    OfferingProfileURL = props.OfferingProfileURL,
    price = props.price,
    digitalAsset = props.digitalAsset,
    isWithdrawDisabled = props.isWithdrawDisabled,
    openSendReceiveSidePane = props.openSendReceiveSidePane,
    selectInstrument = props.selectInstrument,
    selectedInstrumentId = props.selectedInstrumentId;
  var product = digitalAsset;
  (0, _react.useEffect)(function () {
    if (selectedInstrumentId && ProductId) {
      selectInstrument(selectedInstrumentId);
      props.getProductAttributes([{
        ProductId: ProductId
      }]);
    }
  }, [selectedInstrumentId, ProductId]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, product && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('left')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes('symbol')
  }, digitalAsset.Product), "\xA0\xA0\xA0", /*#__PURE__*/_react["default"].createElement("span", {
    className: classes('product')
  }, digitalAsset.ProductFullName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('right')
  }, /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    iconName: 'deposit',
    action: function action() {
      openSendReceiveSidePane(digitalAsset);
    },
    customClass: classes('padding'),
    label: t("   Buy")
  }), "\xA0\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    style: {
      border: '1px solid red'
    },
    iconName: 'withdraw',
    action: function action() {
      openSendReceiveSidePane(digitalAsset, '1');
    },
    customClass: classes('padding'),
    isDisabled: isWithdrawDisabled,
    label: t("   Sell")
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('left')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes('tabs')
  }, t("Asset Details"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('right')
  }, t("Price:"), " $", price, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t("Number of tokens for sale:"), /*#__PURE__*/_react["default"].createElement(_TotalTokensCount.ConnectedTotalTokens, {
    ProductId: ProductId,
    InstrumentId: selectedInstrumentId
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('iframe-container')
  }, /*#__PURE__*/_react["default"].createElement(_APIFrame["default"], {
    src: OfferingProfileURL,
    title: digitalAsset.Product,
    style: {
      width: '100%',
      height: '100%'
    }
  })))));
};
var _default = exports["default"] = DigitalAssetsOfferingProfilePage;